module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    系統使用率報表模組已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("數據分析 > 趨勢分析")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "z-index-1"
  }, [(_vm.brandBrief.length > 1) ? _c('div', {
    staticClass: "inline-block from-group pull-left ",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "品牌",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeBrand
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 1) ? _c('div', {
    staticClass: "from-group pull-left m-l-5 flex"
  }, [_c('div', {
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeStore
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1), _vm._v(" "), (_vm.storeSelect.value) ? _c('div', {
    staticClass: "ein"
  }, [_vm._v("\n                統編：" + _vm._s(_vm.ein)), _c('br'), _vm._v("抬頭：" + _vm._s(_vm.storeName) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length === 0 && _vm.getRoleType === 10) ? _c('div', {
    staticClass: "ein"
  }, [_vm._v("\n              統編：" + _vm._s(_vm.ein)), _c('br'), _vm._v("抬頭：" + _vm._s(_vm.storeName) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-t-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      active: _vm.isType('daily')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectTab = 'daily'
      }
    }
  }, [_vm._v("每日統計\n                    ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isType('monthly')
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectTab = 'monthly'
      }
    }
  }, [_vm._v("每月統計\n                    ")])])]), _vm._v(" "), (_vm.selectTab === 'daily') ? _c('div', {
    staticClass: "download-block m-r-20"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        return _vm.exportFile('chart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                    匯出圖表\n                  ")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-25 m-l-15"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "text-14 m-r-15 m-l-15"
  }, [_vm._v("資料期間")]), _vm._v(" "), (_vm.selectTab === 'monthly') ? _c('div', {
    staticClass: "flex align-center"
  }, [_c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "month",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.startMonthLimit
    },
    model: {
      value: (_vm.monthlySearch.start_date),
      callback: function($$v) {
        _vm.$set(_vm.monthlySearch, "start_date", $$v)
      },
      expression: "monthlySearch.start_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-l-5 m-r-5"
  }, [_vm._v("-")]), _vm._v(" "), _c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "month",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.endMonthLimit,
      "input-class": "mx-input input-group-input"
    },
    model: {
      value: (_vm.monthlySearch.end_date),
      callback: function($$v) {
        _vm.$set(_vm.monthlySearch, "end_date", $$v)
      },
      expression: "monthlySearch.end_date"
    }
  })], 1) : _c('div', {
    staticClass: "flex align-center"
  }, [_c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "date",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.startDateLimit
    },
    model: {
      value: (_vm.dailySearch.start_date),
      callback: function($$v) {
        _vm.$set(_vm.dailySearch, "start_date", $$v)
      },
      expression: "dailySearch.start_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-l-5 m-r-5"
  }, [_vm._v("-")]), _vm._v(" "), _c('date-picker', {
    staticClass: "w-120",
    attrs: {
      "type": "date",
      "valueType": "format",
      "clearable": false,
      "disabled-date": _vm.endDateLimit,
      "input-class": "mx-input input-group-input"
    },
    model: {
      value: (_vm.dailySearch.end_date),
      callback: function($$v) {
        _vm.$set(_vm.dailySearch, "end_date", $$v)
      },
      expression: "dailySearch.end_date"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default submit-btn input-group-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchOrderSummary()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right"
  }, [(_vm.selectTab === 'monthly') ? _c('div', {
    staticClass: "m-r-20"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10",
    on: {
      "click": function($event) {
        return _vm.setDate('year')
      }
    }
  }, [_vm._v("近一年")])]) : _c('div', {
    staticClass: "m-r-20"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10 m-r-5",
    on: {
      "click": function($event) {
        return _vm.setDate('week')
      }
    }
  }, [_vm._v("近一週")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-primary p-x-10",
    on: {
      "click": function($event) {
        return _vm.setDate('month')
      }
    }
  }, [_vm._v("近一個月")])])])]), _vm._v(" "), _c('div', {
    staticClass: "canvas-block"
  }, [(_vm.selectTab === 'daily') ? _c('div', {
    staticClass: "download-block z-index-1 p-r-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.month),
      expression: "month"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeMonth]
    }
  }, _vm._l((_vm.monthlyOptions), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "disabled": item.disable
      },
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-b-15 chart-title"
  }, [_vm._v("ORDER")]), _vm._v(" "), _c('div', {
    staticClass: "chart-subtitle m-b-5"
  }, [_vm._v("系統觸發/使用次數統計")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "order-chart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-64 m-b-15 chart-title"
  }, [_vm._v("CRM")]), _vm._v(" "), _c('div', {
    staticClass: "chart-subtitle m-b-5"
  }, [_vm._v("系統觸發/使用次數統計")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "crm-chart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-64 m-b-15 m-b-5 chart-title"
  }, [_vm._v("DATA")]), _vm._v(" "), _c('div', {
    staticClass: "chart-subtitle"
  }, [_vm._v("系統觸發/使用次數統計")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "data-chart"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-662c184c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/SystemUsage.vue
// module id = 2463
// module chunks = 1